import { NgModule } from '@angular/core';
import {DateByTimeZone} from './timezone.pipe';
import {InventoryStatus} from './inventoryStatus.pipe';
import {TimeInMonthsDaysHours} from './monthdayhour.pipe';
import { TimeAgoPipe } from './timeAgo.pipe';
import { ConvertTimePipe } from './formatHHMMSS.pipe';
import { Capitalize } from './capitalise.pipe';
import { SafeHtmlPipe } from './sanitize.pipe';
import { ContainerDetails } from './container.pipe';
import { GetTotalCntFromDifferentTypesPipe } from './get-total-cnt-from-different-types.pipe';
import { CurrencyPipe } from './currency.pipe';
@NgModule({
  declarations: [CurrencyPipe,DateByTimeZone,InventoryStatus, TimeInMonthsDaysHours,TimeAgoPipe,ConvertTimePipe,Capitalize, GetTotalCntFromDifferentTypesPipe,SafeHtmlPipe,ContainerDetails],
  imports: [  ],
  exports:[CurrencyPipe,DateByTimeZone,InventoryStatus, TimeInMonthsDaysHours,TimeAgoPipe,ConvertTimePipe,Capitalize, GetTotalCntFromDifferentTypesPipe,SafeHtmlPipe,ContainerDetails]
})
export class PipesModule { }
